import { ProductPackageConfigurationMode } from '@src/core/buyerApiClient';

// A plain boolean gate rather than a feature-flag-typed parameter: this domain function has no
// notion of feature flags, so it stays correct as-is once the flag is retired and callers just
// stop passing it in (or pass true unconditionally).
export function shouldUseSingleBookingPackageBooking(
  configurationMode: string | undefined,
  isEnabled: boolean,
): boolean {
  return configurationMode === ProductPackageConfigurationMode.SingleBooking && isEnabled;
}
